import formatAssessmentItemOption from '$utils/formatAssessmetItemOption';
import isArrayEmpty from './isArrayEmpty';

const filterAssessmentItemOptions = ({
  selectedAssessmentItemId,
  assessmentItems,
}) => {
  if (isArrayEmpty(assessmentItems)) {
    return [];
  }

  return assessmentItems
    .filter(
      ({ id, linkedAssessments = [] }) =>
        id !== selectedAssessmentItemId &&
        (linkedAssessments.length === 0 ||
          linkedAssessments.includes(selectedAssessmentItemId))
    )
    .map(({ title, id }) => formatAssessmentItemOption({ title, id }));
};

export default filterAssessmentItemOptions;
